import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=49773e1e&scoped=true"
import script from "./Lotto.vue?vue&type=script&lang=js"
export * from "./Lotto.vue?vue&type=script&lang=js"
import style0 from "./Lotto.vue?vue&type=style&index=0&id=49773e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49773e1e",
  null
  
)

export default component.exports